import React from "react";

function InfoIconOutline() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				fill="#AA4900"
				d="M8 4.667c.367 0 .667.3.667.667v2.667c0 .366-.3.666-.667.666a.669.669 0 01-.667-.666V5.334c0-.367.3-.667.667-.667zm-.007-3.333a6.663 6.663 0 00-6.66 6.667c0 3.68 2.98 6.666 6.66 6.666a6.67 6.67 0 006.674-6.666 6.67 6.67 0 00-6.674-6.667zm.007 12a5.332 5.332 0 01-5.333-5.333A5.332 5.332 0 018 2.667a5.332 5.332 0 015.333 5.334A5.332 5.332 0 018 13.334zm.667-2H7.333v-1.333h1.334v1.333z"
			/>
		</svg>
	);
}

export default InfoIconOutline;
